import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';

import {
  MemberRewardPickupCriteria,
  MemberRewardPickupHistory,
  MemberRewardPickupPagination
} from '../models/member-reward-pickup';

@Injectable({
  providedIn: 'root'
})
export class MemberRewardPickupService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.memberRewardPickup;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  searchMemberRewardPickupList(payload: MemberRewardPickupCriteria) {
    const url = this.getFullUrlWithStoreCode(this.envService.list);
    const params = this.getParams(payload, true);
    return this.http.get<MemberRewardPickupPagination>(url, {
      headers: this.headers,
      observe: 'body',
      params
    });
  }

  submitConfirmPickup(receiptNo: string, version: number) {
    const url = this.getFullUrl(this.envService.confirm, {});
    return this.http.post<MemberRewardPickupPagination>(
      url,
      { receiptNo, version },
      {
        headers: this.headers,
        observe: 'body'
      }
    );
  }

  getHistory(receiptNo: string) {
    const url = this.getFullUrl(this.envService.history, { receiptNo });
    return this.http.get<MemberRewardPickupHistory>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }
}
